import { connect } from '~/store';

/** Store helper: provides all automated guesses of the user's current electorates. */
export default (component: any): (props: any) => any => (
  connect(({ guesses }: { guesses: object[] }) => ({ guesses }))(component)
);
